import { createStore } from 'vuex';

export default createStore({
  // 定义 Vuex 的 state，存储应用的状态
  state: {
    user: null // 当前用户的登录信息，默认为 null
  },
  // 定义 mutations，用于同步更新 state
  mutations: {
    // 设置用户信息
    setUser(state, user) {
      state.user = user;
    },
    // 清除用户信息
    clearUser(state) {
      state.user = null;
    }
  },
  // 定义 actions，用于处理异步操作或复杂逻辑
  actions: {
    // 用户登录操作
    login({ commit }, user) {
      commit('setUser', user); // 提交 mutation 更新 state
    },
    // 用户登出操作
    logout({ commit }) {
      commit('clearUser'); // 提交 mutation 清除用户信息
    }
  },
  // 定义 getters，用于从 state 计算派生状态
  getters: {
    // 判断用户是否已登录
    isAuthenticated: (state) => !!state.user, // 如果 state.user 不为 null，则返回 true
    // 获取当前用户信息
    user: (state) => state.user
  }
});
